import { render, staticRenderFns } from "./CreateTicketButton.vue?vue&type=template&id=dec262bc"
import script from "./CreateTicketButton.vue?vue&type=script&lang=js"
export * from "./CreateTicketButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports